import { TEXTS } from './texts';

export const NOTIFICATIONS_TEXT = {
  STOPPED: TEXTS.AD_CAMPAIGN_STOPPED,
  STARTED: TEXTS.AD_CAMPAIGN_STARTED,
  CREATE_SUCCESS: TEXTS.MODAL_AD_CREATE_SUCCESS_MESSAGE,
  RENAME_SUCCESS: TEXTS.MODAL_AD_RENAME_SUCCESS_MESSAGE,
  REMOVE_SUCCESS: TEXTS.MODAL_AD_REMOVE_SUCCESS_MESSAGE,
  REPORT_CREATE_SUCCESS: TEXTS.MODAL_AD_REPORT_CREATE_SUCCESS_MESSAGE,
  MAX_LENGTH_ERROR: TEXTS.NAME_MAX_LENGTH_ERROR_MESSAGE,
  CANNOT_STOP_ERROR: TEXTS.INSTANT_AD_CANNOT_STOP_MESSAGE,
  COPY_SUCCESS: TEXTS.MODAL_AD_COPY_SUCCESS_MESSAGE,
};

export const NAME_MAX_LENGTH_ERROR = 'value too long for type character';
export const INSTANT_AD_CANNOT_STOP_ERROR = /INSTANT/;
